import http from '@/utils/http';
import utils from '@/utils/common';

/**
 * 获取列表-lx
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/goal/scenario/system/base/page',
        method: 'post',
        data
    });
};

/**
 * 导入-lx
 */
export function importApi(data) {
    return http({
        url: '/api-lcrm/goal/scenario/system/base/import',
        method: 'post',
        data
    });
};

/**
 * 导出-lx
 */
export function exportApi(data) {
    return http({
        url: '/api-lcrm/goal/scenario/system/base/export',
        method: 'post',
        data
    });
};

// 模板下载-lx
export const exportTempApi = (params) => {
    return http({
        url: '/api-lcrm/goal/scenario/system/base/download',
        method: 'post',
        responseType: 'blob',
        data: params
    }).then(res => {
        utils.downloadStream(res, params.fileName);
    });
};
